import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";

export default function FaqAccordion({ items, testidPrefix = "faq" }) {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <div className="divide-y divide-slate-200 border-y border-slate-200" data-testid={`${testidPrefix}-list`}>
      {items.map((item, i) => (
        <div key={i}>
          <button
            type="button"
            data-testid={`${testidPrefix}-trigger-${i + 1}`}
            aria-expanded={openIdx === i}
            onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
            className="group flex w-full items-center justify-between gap-6 py-6 text-left"
          >
            <span className="font-display text-base font-semibold text-slate-900 transition-colors duration-300 group-hover:text-brand-red sm:text-lg">
              {item.q}
            </span>
            <motion.span
              animate={{ rotate: openIdx === i ? 45 : 0 }}
              transition={{ duration: 0.3 }}
              className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-300 ${
                openIdx === i
                  ? "border-brand-red bg-brand-red text-white"
                  : "border-slate-300 text-slate-500 group-hover:border-brand-red group-hover:text-brand-red"
              }`}
            >
              <Plus className="h-4 w-4" />
            </motion.span>
          </button>
          <AnimatePresence initial={false}>
            {openIdx === i && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="overflow-hidden"
              >
                <p
                  data-testid={`${testidPrefix}-answer-${i + 1}`}
                  className="max-w-3xl pb-7 text-sm leading-relaxed text-slate-600 sm:text-base"
                >
                  {item.a}
                </p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}
